import { mountSingleRace } from './utils/mount-single-race.js';
mountSingleRace(
  'city-of-inglewood-primary-nominating-election-mayor-4348'
).catch(console.error);
